/**
 * @generated SignedSource<<301125f46ff1e599419211d8bece5d0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSearchParams = {
  adults: number;
  arrivalAirport: string;
  children?: number | null;
  departureAirport: string;
  departureDate: string;
  directOnly?: boolean | null;
  infant?: number | null;
  returnDate: string;
};
export type PackageDateAddFlightDialogQuery$variables = {
  params?: FlightSearchParams | null;
};
export type PackageDateAddFlightDialogQuery$data = {
  readonly flightsSearch: {
    readonly " $fragmentSpreads": FragmentRefs<"FlightSearchResults_results">;
  };
};
export type PackageDateAddFlightDialogQuery = {
  response: PackageDateAddFlightDialogQuery$data;
  variables: PackageDateAddFlightDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "params",
    "variableName": "params"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supplier",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "price",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "departDatetime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "arrivalDatetime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "departAirportCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "arrivalAirportCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "departCity",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "arrivalCity",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "carrier",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "flightNumber",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "duration",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "direction",
    "storageKey": null
  },
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PackageDateAddFlightDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FlightSearchResult",
        "kind": "LinkedField",
        "name": "flightsSearch",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FlightSearchResults_results"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PackageDateAddFlightDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FlightSearchResult",
        "kind": "LinkedField",
        "name": "flightsSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlightJson",
            "kind": "LinkedField",
            "name": "flights",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priceKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "provider",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookingToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priceLive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priceSupplier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FlightSegmentJson",
                "kind": "LinkedField",
                "name": "forwardSegments",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FlightSegmentJson",
                "kind": "LinkedField",
                "name": "returnSegments",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "forwardSegments",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "returnSegments",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isUpdating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightPrice",
                        "kind": "LinkedField",
                        "name": "lastSuccessfulUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Flight",
                    "abstractKey": null
                  }
                ],
                "type": "FlightType",
                "abstractKey": "__isFlightType"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df8ee7337295c97bcf8b3f6ef9d633da",
    "id": null,
    "metadata": {},
    "name": "PackageDateAddFlightDialogQuery",
    "operationKind": "query",
    "text": "query PackageDateAddFlightDialogQuery(\n  $params: FlightSearchParams\n) {\n  flightsSearch(params: $params) {\n    ...FlightSearchResults_results\n  }\n}\n\nfragment FlightDetailsPrice_flight on Flight {\n  priceLive\n  isUpdating\n  lastSuccessfulUpdate {\n    createdAt\n    id\n  }\n  ...FlightListProvider_flight\n}\n\nfragment FlightDetails_flight on FlightType {\n  __isFlightType: __typename\n  ...FlightDetailsPrice_flight\n  forwardSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n  returnSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n}\n\nfragment FlightInfoEndpoint_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoFullSegment_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoSegmentInfo_segment on FlightSegment {\n  supplier\n  flightNumber\n  departDatetime\n  arrivalDatetime\n}\n\nfragment FlightInfo_segments on FlightSegment {\n  arrivalDatetime\n  departDatetime\n  duration\n  ...FlightInfoFullSegment_segment\n  ...FlightInfoEndpoint_segment\n  ...FlightInfoSegmentInfo_segment\n}\n\nfragment FlightListProvider_flight on Flight {\n  provider\n}\n\nfragment FlightSearchResult_flight on FlightJson {\n  ...FlightDetails_flight\n  ...FlightSearchResult_makeFlightInput\n}\n\nfragment FlightSearchResult_makeFlightInput on FlightJson {\n  provider\n  supplier\n  priceKey\n  bookingToken\n  priceLive\n  priceSupplier\n  forwardSegments {\n    price\n    departDatetime\n    arrivalDatetime\n    departAirportCode\n    arrivalAirportCode\n    departCity\n    arrivalCity\n    supplier\n    carrier\n    flightNumber\n    duration\n    direction\n    id\n  }\n  returnSegments {\n    price\n    departDatetime\n    arrivalDatetime\n    departAirportCode\n    arrivalAirportCode\n    departCity\n    arrivalCity\n    supplier\n    carrier\n    flightNumber\n    duration\n    direction\n    id\n  }\n}\n\nfragment FlightSearchResults_results on FlightSearchResult {\n  flights {\n    priceKey\n    ...FlightSearchResult_flight\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7ac7425066dc334abef19fc5741f054";

export default node;
